module.exports = __webpack_public_path__ + "static/img/economy.59e0a587.png";